module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [(_vm.loading) ? _c('div', {
    attrs: {
      "id": "overlay"
    }
  }, [_c('div', {
    staticClass: "spinner"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Loading...")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box box-info"
  }, [_c('form', [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-mt-2"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "purchaseSalesDate"
    }
  }, [_vm._v("Order Date")]), _vm._v(" "), (!_vm.englishDateEnabled) ? _c('date-picker', {
    ref: "tran",
    attrs: {
      "valueType": "format"
    },
    model: {
      value: (_vm.purchaseSalesDate),
      callback: function($$v) {
        _vm.purchaseSalesDate = $$v
      },
      expression: "purchaseSalesDate"
    }
  }) : _c('input-mask', {
    ref: "tran",
    staticClass: "nepali-calendar",
    attrs: {
      "mask": "9999-99-99",
      "type": "text",
      "id": "purchaseSalesDate"
    },
    model: {
      value: (_vm.purchaseSalesDate),
      callback: function($$v) {
        _vm.purchaseSalesDate = $$v
      },
      expression: "purchaseSalesDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "orderNo"
    }
  }, [_vm._v("Order No")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "orderNo",
      "disabled": ""
    },
    model: {
      value: (_vm.orderNo),
      callback: function($$v) {
        _vm.orderNo = $$v
      },
      expression: "orderNo"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "warehouse"
    }
  }, [_vm._v("Store")]), _vm._v(" "), (!_vm.setWarehouseData) ? _c('Dropdown', {
    attrs: {
      "options": _vm.warehouseLists,
      "optionLabel": "name",
      "id": "warehouse",
      "filter": true,
      "placeholder": "Select warehouse",
      "showClear": true
    },
    model: {
      value: (_vm.warehouseId),
      callback: function($$v) {
        _vm.warehouseId = $$v
      },
      expression: "warehouseId"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.setWarehouseData) ? _c('Dropdown', {
    attrs: {
      "options": _vm.warehouseLists,
      "optionLabel": "name",
      "id": "warehouse",
      "filter": true,
      "placeholder": "Select warehouse",
      "disabled": true
    },
    model: {
      value: (_vm.warehouseId),
      callback: function($$v) {
        _vm.warehouseId = $$v
      },
      expression: "warehouseId"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-1 align-self-end"
  }, [_c('wearhouseDialog', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: ('Add Warehouse'),
      expression: "'Add Warehouse'",
      modifiers: {
        "top": true
      }
    }],
    staticClass: "btn-btm-0",
    on: {
      "set_data_warehouse": _vm.set_data_warehouse
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-mt-2"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "party"
    }
  }, [_vm._v("Customer")]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "options": _vm.supplierAndCustomerList,
      "optionLabel": "name",
      "filter": true,
      "placeholder": "Select Customer",
      "showClear": true
    },
    model: {
      value: (_vm.accountMasterId),
      callback: function($$v) {
        _vm.accountMasterId = $$v
      },
      expression: "accountMasterId"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-1 align-self-end"
  }, [_c('customerDialog', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: ('Add Customer'),
      expression: "'Add Customer'",
      modifiers: {
        "top": true
      }
    }],
    staticClass: "btn-btm-0",
    on: {
      "set_customer_master": _vm.set_customer_master
    }
  })], 1), _vm._v(" "), (_vm.accountMasterId.id > 0) ? _c('div', {
    staticClass: "p-field p-col-12 p-md-2 p-mt-5"
  }, [_c('label', {
    attrs: {
      "for": "panNo"
    }
  }, [_vm._v("Cur. Bal:")]), _vm._v(" "), (_vm.accountMasterId.closingBalance > 0) ? _c('b', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s((_vm.accountMasterId.closingBalance) + 'Cr'))]) : _c('b', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v(_vm._s((_vm.accountMasterId.closingBalance * (-1)).toFixed(2) + 'Dr'))])]) : _vm._e(), _vm._v(" "), (_vm.accountMasterId.id > 0) ? _c('div', {
    staticClass: "p-field p-col-12 p-md-2 p-mt-5"
  }, [(_vm.accountMasterId.id > 0) ? _c('label', {
    attrs: {
      "for": "panNo"
    }
  }, [_vm._v("Pan No:")]) : _vm._e(), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.accountMasterId.panNo !== '' ? _vm.accountMasterId.panNo : 'N/A'))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "party"
    }
  }, [_vm._v("Order From")]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "options": _vm.orderFrom,
      "optionLabel": "label",
      "optionValue": "value",
      "placeholder": "Select Order From"
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(slotProps) {
        return [_c('span', [_vm._v(_vm._s(slotProps.option.label))])]
      }
    }]),
    model: {
      value: (_vm.orderFrm),
      callback: function($$v) {
        _vm.orderFrm = $$v
      },
      expression: "orderFrm"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "party"
    }
  }, [_vm._v("Transport Details")]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "options": _vm.transportationDetailsLists,
      "optionLabel": "name",
      "id": "warehouse",
      "filter": true,
      "placeholder": "Select transport",
      "showClear": true
    },
    model: {
      value: (_vm.transportId),
      callback: function($$v) {
        _vm.transportId = $$v
      },
      expression: "transportId"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-mt-2"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_vm._m(0), _vm._v(" "), _c('AutoComplete', {
    ref: "itm",
    attrs: {
      "filterMatchMode": "contains",
      "suggestions": _vm.filteredItems,
      "field": "name"
    },
    on: {
      "complete": function($event) {
        return _vm.searchItem($event)
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(slotProps) {
        return [_c('div', {
          staticStyle: {
            "font-size": "12px !important"
          }
        }, [_vm._v(_vm._s(slotProps.item.name) + " - " + _vm._s(slotProps.item.itemCode))])]
      }
    }]),
    model: {
      value: (_vm.items),
      callback: function($$v) {
        _vm.items = $$v
      },
      expression: "items"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-1 align-self-end"
  }, [_c('itemDialog', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: ('Add Item'),
      expression: "'Add Item'",
      modifiers: {
        "top": true
      }
    }],
    on: {
      "set_data_item": _vm.set_data_item
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "quantity"
    }
  }, [_vm._v("Sales Qty")]), _vm._v(" "), _c('InputNumber', {
    attrs: {
      "id": "minmaxfraction",
      "onfocus": "if (this.value === '0.00'){this.value = ''\n}",
      "minFractionDigits": 2,
      "maxFracionDigits": 4
    },
    model: {
      value: (_vm.quantity),
      callback: function($$v) {
        _vm.quantity = $$v
      },
      expression: "quantity"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-1"
  }, [_c('label', {
    attrs: {
      "for": "qty"
    }
  }, [_vm._v("Unit")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.items.unitName),
      callback: function($$v) {
        _vm.$set(_vm.items, "unitName", $$v)
      },
      expression: "items.unitName"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "rate"
    }
  }, [_vm._v("Rate")]), _vm._v(" "), _c('InputNumber', {
    attrs: {
      "id": "minmaxfraction",
      "onfocus": "if (this.value === '0.00'){this.value = ''\n}",
      "minFractionDigits": 2,
      "maxFracionDigits": 4
    },
    model: {
      value: (_vm.rate),
      callback: function($$v) {
        _vm.rate = $$v
      },
      expression: "rate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "total"
    }
  }, [_vm._v("Total")]), _vm._v(" "), _c('InputNumber', {
    attrs: {
      "disabled": "",
      "id": "minmaxfraction",
      "onfocus": "if (this.value === '0.00'){this.value = ''\n}",
      "minFractionDigits": 2,
      "maxFracionDigits": 4
    },
    model: {
      value: (_vm.total),
      callback: function($$v) {
        _vm.total = $$v
      },
      expression: "total"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-1 p-mt-5 align-self-end"
  }, [_c('Button', {
    staticClass: "p-button p-component addNewBtn btn-btm-0",
    attrs: {
      "label": !_vm.editDTO ? 'Add' : 'Update'
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addItemToDTO.apply(null, arguments)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-1 p-mt-5"
  }, [(_vm.editDTO) ? _c('Button', {
    staticClass: "p-button-raised p-button-danger",
    attrs: {
      "id": "action",
      "label": "Cancel"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.itemDTOreset.apply(null, arguments)
      }
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v(_vm._s(_vm.totalAmount) + _vm._s(_vm.findRate) + _vm._s(_vm.setRateFromItem))]), _vm._v(" "), (_vm.items.id > 0) ? _c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-mt-2"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "avlQty"
    }
  }, [_vm._v("Cur. Stock: ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.items.closingStock))])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-12"
  }, [_c('div', [_c('div', {
    staticClass: "scrollable"
  }, [_c('table', {
    staticClass: "table table-bordered "
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.inventoryInOutDetailList), function(item, index) {
    return _c('tbody', {
      key: index
    }, [_c('tr', [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.itemMaster.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.quantity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.rate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.rate * item.quantity))]), _vm._v(" "), _c('td', [_c('Button', {
      staticClass: "p-button-raised p-button-success",
      attrs: {
        "icon": "pi pi-pencil"
      },
      on: {
        "click": function($event) {
          return _vm.editItemFromDTO(item, index)
        }
      }
    }), _vm._v(" "), (_vm.editDTO) ? _c('Button', {
      staticClass: "p-button-raised p-button-danger",
      attrs: {
        "disabled": "",
        "icon": "pi pi-trash"
      },
      on: {
        "click": function($event) {
          return _vm.deleteItemFromDTO(item, index)
        }
      }
    }) : (!_vm.editDTO) ? _c('Button', {
      staticClass: "p-button-raised p-button-danger",
      attrs: {
        "icon": "pi pi-trash"
      },
      on: {
        "click": function($event) {
          return _vm.deleteItemFromDTO(item, index)
        }
      }
    }) : _vm._e()], 1)])])
  })], 2)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-mt-2"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('b', {
    staticStyle: {
      "margin-left": "16em"
    }
  }, [_vm._v(_vm._s(_vm.totalQty))])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('b', {
    staticStyle: {
      "margin-left": "38em"
    }
  }, [_vm._v(_vm._s(_vm.subTotal))])])]), _vm._v(" "), _c('hr')])]), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-3"
  }, [_c('label', [_vm._v("Narration")]), _vm._v(" "), _c('Textarea', {
    attrs: {
      "rows": "6"
    },
    model: {
      value: (_vm.narration),
      callback: function($$v) {
        _vm.narration = $$v
      },
      expression: "narration"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-1 p-pt-6"
  }, [_c('Button', {
    staticClass: "p-button-raised p-button-success",
    attrs: {
      "label": !_vm.editing ? 'Save' : 'Update',
      "icon": "pi pi-save"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.saveSalesOrder.apply(null, arguments)
      }
    }
  })], 1), _vm._v(" "), (_vm.salesOrder == undefined) ? _c('div', {
    staticClass: "p-field p-col-12 p-md-1 p-pt-6"
  }, [_c('Button', {
    staticClass: "p-button-raised p-button-warning",
    attrs: {
      "icon": "pi pi-refresh",
      "label": "Reset"
    },
    on: {
      "click": _vm.reset
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.salesOrder != undefined) ? _c('div', {
    staticClass: "p-field p-col-12 p-md-1 p-pt-6"
  }, [_c('Button', {
    staticClass: "p-button-raised p-button-danger",
    attrs: {
      "label": "Cancel"
    },
    on: {
      "click": function($event) {
        return _vm.goBack()
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-1 p-pt-6"
  }, [_c('Button', {
    staticClass: "p-button-raised p-button-secondary",
    attrs: {
      "icon": "pi pi-print",
      "label": "Print"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2 p-pt-6"
  }, [_c('Button', {
    staticClass: "p-button-raised p-button-secondary",
    attrs: {
      "label": "Generate PDF",
      "icon": "pi pi-download"
    }
  })], 1)])]), _vm._v(" "), _c('Dialog', {
    style: ({
      width: '50vw'
    }),
    attrs: {
      "header": "Customer Details",
      "modal": true,
      "closable": false,
      "visible": _vm.displayCustomerDetails
    },
    on: {
      "update:visible": function($event) {
        _vm.displayCustomerDetails = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('Button', {
          staticClass: "p-button-raised p-button-rounded",
          attrs: {
            "label": "Save"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.closeCustomerDetails.apply(null, arguments)
            }
          }
        }), _vm._v(" "), _c('Button', {
          staticClass: "p-button-raised p-button-danger",
          attrs: {
            "label": "Reset"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.customerDetailsCancel.apply(null, arguments)
            }
          }
        })]
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "name"
    },
    model: {
      value: (_vm.billToName),
      callback: function($$v) {
        _vm.billToName = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "billToName"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "contactNumber"
    }
  }, [_vm._v("Contact Number")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "contactNumber"
    },
    model: {
      value: (_vm.contactNumber),
      callback: function($$v) {
        _vm.contactNumber = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "contactNumber"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "address"
    }
  }, [_vm._v("Address")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "address"
    },
    model: {
      value: (_vm.address),
      callback: function($$v) {
        _vm.address = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "address"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "email"
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "email"
    }
  })], 1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "item"
    }
  }, [_vm._v("Item"), _c('b', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("SN")]), _vm._v(" "), _c('th', [_vm._v("Item Name")]), _vm._v(" "), _c('th', [_vm._v("Quantity")]), _vm._v(" "), _c('th', [_vm._v("Rate")]), _vm._v(" "), _c('th', [_vm._v("Amount")]), _vm._v(" "), _c('th', [_vm._v("Action")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('b', {
    staticStyle: {
      "margin-left": "15em"
    }
  }, [_vm._v("Total:")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36ab0615"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/sales/salesorder.vue
// module id = 2146
// module chunks = 0